import { render, staticRenderFns } from "./MaterialCardLogin.vue?vue&type=template&id=164da908&scoped=true&"
import script from "./MaterialCardLogin.vue?vue&type=script&lang=js&"
export * from "./MaterialCardLogin.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCardLogin.vue?vue&type=style&index=0&id=164da908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164da908",
  null
  
)

export default component.exports